import React from 'react';
import TextInputClearable from '../widget/TextInputClearable';
import search from '../../assets/images/search.svg';

const SearchBar = ({ handleSearch, clearAction, onChange=null}) => {
    return (
        <div className='flex-row' style={{gap: "12px"}}>
            <TextInputClearable id="search_bar" placeholder="Search.." clear_function={clearAction} onChange={onChange}/>
            <div id="search-btn" role='button' onClick={handleSearch} className='search-btn centered'>
                <img src={search}/>
            </div>
        </div>
    );
}

export default SearchBar;

